import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import PropTypes from "prop-types";

const styles = StyleSheet.create({
  page: {
    paddingTop: 32,
    paddingBottom: 32,
    paddingLeft: 24,
    paddingRight: 24,
  },
  section: {
    margin: 6,
  },
  title: {
    textDecoration: "underline",
    textAlign: "center",
    fontSize: 18,
    marginBottom: 16,
  },
  headerContainer: {
    flexDirection: "row",
  },
  header: {
    fontWeight: "bold",
    fontSize: 8,
    flex: 1,
    padding: 4,
    textAlign: "center",
    border: "1px solid #ddd",
    backgroundColor: "#000000",
    color: "#FFFFFF",
  },
  row: {
    flexDirection: "row",
  },
  cell: {
    border: "1px solid #ddd",
    flex: 1,
    padding: 4,
    fontSize: 8,
    textAlign: "center",
  },
});

const ProviderDetailsPdfDoc = ({ data, columns }) => (
  <Document>
    <Page style={styles.page} size="A4" orientation="landscape">
      <View style={styles.section}>
        <Text style={styles.title}>Provider Details</Text>
        <View style={styles.headerContainer}>
          {columns.map((col) => (
            <Text key={col.key} style={styles.header}>{col.header}</Text>
          ))}
        </View>
        {(Array.isArray(data) ? data : []).map((item, index) => (
          <View key={index} style={styles.row}>
            {columns.map((col) => (
              <Text key={col.key} style={styles.cell}>{item[col.key] ?? "--"}</Text>
            ))}
          </View>
        ))}
      </View>
    </Page>
  </Document>
);

ProviderDetailsPdfDoc.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      header: PropTypes.string.isRequired,
    })
  ).isRequired,
};

ProviderDetailsPdfDoc.defaultProps = {
  data: [],
};

export default ProviderDetailsPdfDoc;
